import i18next from 'i18next';
import { isValidZonedDateTime } from 'utils/dateTime';

export const validatePanelForm = (values) => {
  const errors: any = {};

  if (values.blindPanel || values.hideReviews) {
    if (Object.entries(values.blindLabels).length !== values.products.length) {
      errors.blindLabel = i18next.t('panel.blindLabelMandatory');
    }
    if (Object.values(values.blindLabels).indexOf('') > -1) {
      errors.blindLabel = i18next.t('panel.blindLabelMandatory');
    }
  }

  if (values.products.length < 1) {
    errors.products = i18next.t('panel.atLeastOneProduct');
  }

  if (
    !isValidZonedDateTime(values.startTime) ||
    !isValidZonedDateTime(values.endTime)
  ) {
    errors.startTime = i18next.t('panel.validDate');
  } else if (values.startTime.date > values.endTime.date) {
    errors.startTime = i18next.t('panel.validEndDate');
  }

  return errors;
};
